import { Component, type ReactNode } from 'react';

/** Ошибка рендера одной страницы не должна оставлять пользователя с пустым экраном. */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto max-w-md px-4 py-16 text-center">
        <p className="text-4xl">🃏</p>
        <h1 className="mt-3 font-display text-xl">Что-то сломалось на этой странице</h1>
        <p className="mt-2 text-sm text-zinc-500">{this.state.error.message}</p>
        <button className="link mt-4 text-sm" onClick={() => location.reload()}>
          Обновить страницу
        </button>
      </div>
    );
  }
}
